<ap-search-filter
    (searchRequired)="handleSearchRequired($event)"
    [formType]="formType"
    [searchParams]="searchParams"
    [searchTypes]="searchTypes"
></ap-search-filter>

<!-- griglia aggrid dei risultati -->
<se-search-result
    (primaryChanged)="handlePrimaryChange($event)"
    (visibilityChanged)="handleVisibilityChange($event)"
    [canItemBeSelected]="fnCanItemBeSelectedHandler"
    [canPatientHistoryOpenForSelection]="fnCanPatientHistoryOpenForSelectionHandler"
    [disabledShowHideIdList]="disabledShowHideIdList"
    [formType]="formType"
    [getButtonContentForSelection]="fnGetButtonContentForSelectionHandler"
    [idPropertyName]="idPropertyName"
    [isBusy]="isBusy"
    [items]="searchResult$ | async"
    [rowSelection]="rowSelection"
    [showPrimaryColSetting]="true"
    class="ap-search-container-class se-flex-1"
></se-search-result>

<!--  [items]="searchResult$ | async" [rowSelection]="rowSelection"
          [idPropertyName]="idPropertyName" [disabledShowHideIdList]="disabledShowHideIdList"
          [postLoadingSelectionOps]="postLoadingSelectionOps" [canItemBeSelected]="fnCanItemBeSelectedHandler"
          [canItemDoubleClicked]="fnCanItemDoubleClickedHandler"
          [canPatientHistoryOpenForSelection]="fnCanPatientHistoryOpenForSelectionHandler"
          [getTooltipForSelection]="fnGetTooltipForSelectionHandler"
          [keepSelectionAfterSearch]="keepSelectionAfterSearch"
          [isBusy]="isBusy" -->
